export const LOGIN = "LOGIN";
export const USER = "USER";
export const USERUPDATE = "USERUPDATE";
export const PRODUCTSCOMM_UPDATE = "PRODUCTSCOMM_UPDATE"

export type User = {
    type: typeof LOGIN,
    payload: {
        firstName: string,
        lastName: string,
        fullName: string,
        dateOfBirth: Date,
        email: string,
        password: string,
        sellerOnBoardingStep: string,
        isActive: boolean,
        Permission:any
    }
}

export type UserDetails = {
    type: typeof USER,
    payload: {
        firstName: string,
        lastName: string,
        fullName: string,
        dateOfBirth: Date,
        email: string,
        password: string
    }
}


export type UserUpdate = {
    type: typeof USERUPDATE,
    payload: {
        firstName: string,
        lastName: string,
        fullName: string,
        dateOfBirth: Date,
        email: string,
        password: string
    }
}

export type productCommUpdate  = {
    type: typeof PRODUCTSCOMM_UPDATE,     
    payload: {
        bankname: string,
         
    }
}


export type UserDispatchTypes = User | UserDetails | UserUpdate | productCommUpdate
